module.exports = __webpack_public_path__ + "img/phone.1fc8207a.svg";